import type { PlaygroundRunOutputResponse } from "contracts/api/playground";
import { For, Show } from "solid-js";
import { PanelSection } from "./PanelSection";

type Finding = PlaygroundRunOutputResponse["findings"][number];
type Assessment = PlaygroundRunOutputResponse["assessments"][number];

/** The qualitative halves of a run: concrete findings and the Content Fitness
 * subcriterion assessments, each shown only when it produced rows. */
export function RunFindings(props: {
  findings: Finding[];
  assessments: Assessment[];
}) {
  return (
    <>
      <Show when={props.findings.length > 0}>
        <PanelSection title="Findings" count={props.findings.length}>
          <For each={props.findings}>
            {(finding) => (
              <div class="check-box">
                <p>
                  <span class={`badge badge-sev sev-${finding.severity}`}>
                    {finding.severity}
                  </span>{" "}
                  <strong>{finding.title}</strong>{" "}
                  <span class="mono">{finding.metricKey}</span>
                </p>
                <p>{finding.detail}</p>
                <Show when={finding.recommendedAction}>
                  <p class="landing-sub">→ {finding.recommendedAction}</p>
                </Show>
              </div>
            )}
          </For>
        </PanelSection>
      </Show>

      <Show when={props.assessments.length > 0}>
        <PanelSection
          title="Content Fitness"
          count={props.assessments.length}
          flush
        >
          <table class="tbl">
            <thead>
              <tr>
                <th>Subcriterion</th>
                <th>State</th>
                <th>Score</th>
                <th>Rationale</th>
              </tr>
            </thead>
            <tbody>
              <For each={props.assessments}>
                {(assessment) => (
                  <tr>
                    <td class="mono">{assessment.subcriterionKey}</td>
                    <td>
                      <span class="badge">{assessment.verificationState}</span>
                    </td>
                    <td>{assessment.score ?? "—"}</td>
                    <td>{assessment.rationale}</td>
                  </tr>
                )}
              </For>
            </tbody>
          </table>
        </PanelSection>
      </Show>
    </>
  );
}
